import React, { useState } from 'react';
import { Popup } from 'zarm';
import { Icon } from '@iyunbao/components';

type PropsRules = {
  prefixCls: string;
  dataSource: any[];
}

const WarnRules = (props: PropsRules) => {
  const { prefixCls, dataSource } = props;
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  if (Array.isArray(dataSource) && dataSource.length) {
    const rule = dataSource[0];

    const optionNode = (options) => {
      if (Array.isArray(options) && options.length) {
        return options.map((item, key) => (
          <div className="warn-rule-item" key={`item_${key}`}>
            <div className="item-label">{item.label}</div>
            <div className="item-value">{item.value}</div>
          </div>
        ));
      }

      return null;
    };

    const popupNode = () => {
      if (!rule.tips) {
        return null;
      }

      const { label, options } = rule.tips || {};

      return (
        <Popup
          visible={visible}
          direction="bottom"
          className={`${prefixCls}-popup`}
          onMaskClick={() => onClose()}
        >
          {label.length > 0 && (
            <div className="popup-header">
              <h2 className="title">{label}</h2>
              <div className="button-clone" onClick={() => onClose()} />
            </div>
          )}
          <div className="popup-body">
            {
              optionNode(options)
            }
          </div>
        </Popup>
      );
    };

    return (
      <div className={prefixCls}>
        {rule.label}
        {rule.tips ? <Icon type="wenhao" onClick={() => setVisible(true)} /> : null}
        {popupNode()}
      </div>
    );
  }

  return null;
};

export default WarnRules;
